import { useState } from "react";
import { toast } from "sonner";
import { formatApiError, runAiJob } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { Sparkle, Plus, Check } from "@phosphor-icons/react";

export const RelatedSuggestions = ({ selection, onAdd, apiBase = "/sop" }) => {
  const { aiEnabled } = useAuth();
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState(null);
  const ids = Object.keys(selection);

  const run = async () => {
    if (!ids.length) return toast.error("Pick at least one requirement first");
    setBusy(true);
    try {
      const data = await runAiJob(`${apiBase}/suggest-related`, { requirement_ids: ids });
      setItems(data.suggestions || []);
      if (!data.suggestions?.length) toast.info("No additional related requirements found");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-2">
      <Button data-testid="sop-suggest-related-btn" type="button" variant="outline" onClick={run} disabled={busy || !aiEnabled}
        title={!aiEnabled ? "AI features are turned off — pick requirements manually" : "Uses 1 AI credit"} className="rounded-none w-full h-8 text-xs">
        <Sparkle size={14} weight="fill" className="mr-1" />{busy ? "Finding related requirements…" : "Suggest related requirements (AI)"}
      </Button>
      {items && items.length > 0 && (
        <div className="border border-dashed border-primary/40 bg-primary/[0.03]" data-testid="sop-suggestions-list">
          <div className="px-2 py-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">AI suggestions — review before adding</div>
          {items.map((s) => {
            const added = selection[s.requirement_id] !== undefined;
            return (
              <div key={s.requirement_id} className="flex items-start gap-2 px-2 py-1.5 border-t border-border text-xs" data-testid={`sop-suggestion-${s.standard_id}-${s.req_number}`}>
                <div className="flex-1">
                  <span className="font-mono font-semibold">{s.standard_id} {s.req_number}</span>
                  {s.reason && <div className="text-muted-foreground">{s.reason}</div>}
                </div>
                <Button data-testid={`sop-suggestion-add-${s.standard_id}-${s.req_number}`} size="sm" variant="ghost" disabled={added}
                  onClick={() => onAdd(s)} className="rounded-none h-6 px-2">
                  {added ? <Check size={12} /> : <Plus size={12} />}
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
